import * as Sentry from '@sentry/react';

type ErrorContext = Record<string, any>;

const logError = (error: Error, context?: ErrorContext) => {
    console.error('Error:', error);
    if (context) {
        console.error('Context:', context);
    }
};

const initErrorTracking = () => {
    if (process.env.NODE_ENV === 'production') {
        const dsn = import.meta.env.VITE_SENTRY_DSN;
        if (!dsn || dsn === 'your_sentry_dsn_here' || !dsn.startsWith('https://')) {
            return;
        }
        try {
            Sentry.init({
                dsn,
                environment: process.env.NODE_ENV,
                tracesSampleRate: 1.0,
            });
        } catch (error) {
            console.error('Failed to initialize error tracking:', error);
        }
    }
};

export { initErrorTracking, logError };
